import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { EmailStep } from 'page/ProfileScreen/Email/EmailStep'
import { ProfileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModal'
import { profileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModalStore'
import { FullStep } from 'page/ProfileScreen/Simple/FullStep'
import { ProfileStep } from 'page/ProfileScreen/Simple/ProfileStep'
import { SelfieStep } from 'page/ProfileScreen/Simple/SelfieStep'
import { controller } from 'store/controller'
import { store } from 'store/store'

export const SimpleProfilePage = observer(() => {
  const { stage } = store.profile.simple

  const onBack = useLatestCallback(() => {
    const identity = !!store.profile.identity_id
    const next = stage !== 'profile'
    if (identity && next) {
      store.profile.simple.stage = 'profile'
    } else {
      controller.closeProfile()
    }
  })

  return (
    <Page tall onBack={onBack}>
      <Vertical tall center>
        <Vertical tall wide center maxWidth="var(--max-width)">
          {stage === 'profile' && <ProfileStep />}
          {stage === 'selfie' && <SelfieStep />}
          {stage === 'full' && <FullStep countdown={5} />}
        </Vertical>
      </Vertical>

      {profileDeleteModal.present && <ProfileDeleteModal />}

      {store.profile.step === 'email' && <EmailStep />}
    </Page>
  )
})
